export interface SwaPrincipal {
  identityProvider: string;
  userDetails: string; // email
  userId: string;
  userRoles: string[];
}

export async function getSwaPrincipal(): Promise<SwaPrincipal | null> {
  const res = await fetch("/.auth/me");
  if (!res.ok) return null;
  const data = (await res.json()) as { clientPrincipal: SwaPrincipal | null };
  return data.clientPrincipal;
}

export function loginUrl(): string {
  return "/.auth/login/aad?post_login_redirect_uri=/";
}

export function logoutUrl(): string {
  return "/.auth/logout?post_logout_redirect_uri=/login";
}
